// removed by extract-text-webpack-plugin
module.exports = {"react-django-template":"SearchUnitStandaloneLayout__react-django-template___-hash--base64-5-"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/layouts/SearchUnitStandaloneLayout/SearchUnitStandaloneLayout.scss
 ** module id = 964
 ** module chunks = 1
 **/